import React from "react";

import { Campaign } from "@dndModels";

import RulesReference from "@dndComponents/campaign/rules/RulesReference";

interface Props {
  campaign?: Campaign;
}

export default function QuickRulesControl({ campaign }: Props) {
  return (
    <RulesReference campaign={campaign} />
  );
}
